import { pillTone } from "utils/soloAccuracy";

// Each student's Solo Time record, as the backend counted it, taken from the
// `solo_accuracy` list on the session row.
//
// Shown in place of the math level bullets: the fraction itself, coloured by
// accuracy. Which questions count is governed by the universal rule (see
// SOLO_ACCURACY_RULE in utils/soloAccuracy): "Solo Accuracy counts the
// questions you were in the room for when Solo Time ended; Team Time answers
// never change it".
//
// The row keys students by id. The report identifies them by name, so the
// caller supplies the id -> name mapping it already holds — the same one the
// challenge rows carry. A student whose name cannot be resolved is kept under
// their pseudonym (their student_id).

const EMPTY = {};

export const pillsByName = (students, nameById = {}) => {
  if (!Array.isArray(students) || students.length === 0) return EMPTY;

  const byName = {};
  students.forEach((student) => {
    const id = student?.student_id;
    if (!id && !student?.student_name) return;
    const name =
      (nameById && id ? nameById[id] : null) ||
      student?.pseudonym ||
      student?.student_name ||
      id;
    if (!name) return;
    const {
      correct,
      answered,
      accuracy,
      math_level: mathLevel,
    } = student;
    const notApplicable = Boolean(
      student?.not_applicable === true || student?.notApplicable === true
    );
    const notApplicableReason =
      student?.not_applicable_reason || student?.notApplicableReason || null;
    const record = {
      correct,
      answered,
      // Only the numbers: the words in front of them are the bullet's title and
      // are rendered outside the pill.
      fraction: notApplicable ? null : `${correct} of ${answered}`,
      tone: notApplicable ? null : pillTone(accuracy),
      accuracy,
      // The compiler's own level, from the same result as the fraction. Absent
      // when it withheld one for too few attempts.
      mathLevel,
      ...(notApplicable
        ? {
            notApplicable: true,
            not_applicable: true,
            notApplicableReason,
            not_applicable_reason: notApplicableReason,
          }
        : {}),
    };
    byName[String(name).toLowerCase()] = record;
    if (id && String(id).toLowerCase() !== String(name).toLowerCase()) {
      byName[String(id).toLowerCase()] = record;
    }
  });
  return byName;
};
